/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from "react";
import ReactApexChart from "react-apexcharts";

function DonutViewChart({ data }: any) {
  const [state, setState] = React.useState<any>({
    series: [],
    options: {
      chart: {
        width: 380,
        type: "pie",
      },
      labels: [],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    },
  });

  useEffect(() => {
    if (data?.length) {
      setState((prevState: any) => ({
        options: {
          ...prevState.options,
          labels: data?.map((item: any) => item?.status),
        },
        series: data?.map((item: any) => Number(item?.count)),
      }));
    }
  }, [data]);

  return state.series.length ? (
    <ReactApexChart options={state.options} series={state.series} type="pie" />
  ) : null;
}

export default DonutViewChart;
